import type { SubscriptionOverviewResponse } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { subscriptionKeys } from "@/hooks/queryKeys";
import { useUser } from "@/hooks/useUser";

export function useSubscriptionOverview(
  projectId: number,
): UseQueryResult<SubscriptionOverviewResponse> {
  const { data: userData } = useUser();

  return useQuery<SubscriptionOverviewResponse>({
    enabled: !!userData,
    queryFn: () => {
      const project = userData!.projects.find((p) => p.id === projectId);

      if (!project) {
        throw new Error("Project not found");
      }

      return {
        account: {
          id: project.id,
          name: project.name,
        },
        addOns: null,
        paymentMethods: null,
        plan: {
          designSlotCount: null,
          productName: project.product,
          supportTier: null,
        },
        subscriptionStatus: project.subscriptionStatus.subscriptionStatus,
        upcomingPayment: {
          amount: project.price,
          currency: "USD",
          discount: null,
          renewalDate: new Date(project.nextBillingDate).toISOString(),
        },
      };
    },
    queryKey: subscriptionKeys.overview(projectId),
  });
}
